export const CACHE_KEY_LIST_APPROVAL_QUEUE = 'approvalQueues';
export const CACHE_KEY_APPROVAL_QUEUE = 'approvalQueue-one';
export const ROUTE_PATH_APPROVAL_QUEUE = '/tools/approval-queues';
export const TRANSLATION_PREFIX_APPROVAL_QUEUE = 'approvalQueue';
export const SECURITY_KEY_APPROVAL_QUEUE = 'APPROVAL_QUEUE';


export const APPROVAL_STATUS_APPEARANCE = {
  DRAFT: {color: 'gray'},
  PENDING: {color: 'red'},
  AUTHORIZED: {color: '#9AB090FF'},
  PDF_GENERATED: {color: 'orange'},
  PDF_SIGNED: {color: '#338DC8'},
  COMPLETED: {color: 'green'}
};

export const APPROVAL_QUEUE_STATUS = [
  'DRAFT',
  'PENDING',
  'AUTHORIZED',
  'PDF_GENERATED',
  'PDF_SIGNED',
  'COMPLETED'
];

export const APPROVAL_STATUS = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  AUTHORIZED: 'AUTHORIZED',
  PDF_GENERATED: 'PDF_GENERATED',
  PDF_SIGNED: 'PDF_SIGNED',
  COMPLETED: 'COMPLETED'
};

export const STEP_CONFIRM_MODAL = {
  title: 'Importante',
  content: 'Algunas solicitudes asociadas a esta orden ya no se encuentran en estado VALIDADA y serán descartadas. Usted puede continuar el proceso con el resto de las solicitudes.',
  cancel: 'Cancelar'
};

